import { useEffect, useState } from "react";
import { fetchStatusAtivos } from '../api';

export function useStatusOptions() {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const data = await fetchStatusAtivos();
        setOptions(data.map(s => ({
          value: s.id,
          label: s.descricao,
          exige_motivo: s.exige_motivo
        })));
      } catch (err) {
        console.error("Erro ao carregar status:", err);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, []);

  return { options, loading };
}
